import { getDevPortalBaseUrl } from './environment';

export const buildDevPortalUrl = (endpoint: string): string => {
  const baseUrl = getDevPortalBaseUrl();

  return `${baseUrl}/${endpoint}`;
};
